/**
 * Pages components index file
 * Exports all page components from the pages directory
 */

// Import page components
import BookWorksheetPageEnh from './BookWorksheetPage-enh';
import BookWorksheetPageWrapperEnh from './BookWorksheetPageWrapper-enh';

// Export page components
export {
  BookWorksheetPageEnh,
  BookWorksheetPageWrapperEnh
};

// Export default
export default {
  BookWorksheetPageEnh,
  BookWorksheetPageWrapperEnh
};
